// src/services/athlete.service.js
import { baseApi } from "./base.api";
import { API_CONFIG } from "../config/api.config";

class AthleteService {
  createAthlete(data) {
    return baseApi.post(API_CONFIG.ENDPOINTS.ATHLETE.CREATE, data);
  }

  // accept optional params object, e.g. { trainerId, limit, offset }
  getAthletes(params = {}) {
    let url = API_CONFIG.ENDPOINTS.ATHLETE.SHOW;
    if (params && Object.keys(params).length > 0) {
      const qs = Object.keys(params)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join("&");
      url = `${url}?${qs}`;
    }
    return baseApi.get(url);
  }

  getAthleteById(id) {
    return baseApi.get(API_CONFIG.ENDPOINTS.ATHLETE.SEARCH_BY_ID(id));
  }

  // fetch dashboard/profile for logged-in athlete
  getMyDashboard(params = {}) {
    let url = API_CONFIG.ENDPOINTS.ATHLETE.ME;
    if (params && Object.keys(params).length > 0) {
      const qs = Object.keys(params)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join("&");
      url = `${url}?${qs}`;
    }
    return baseApi.get(url);
  }

  searchByName(payload) {
    return baseApi.post(API_CONFIG.ENDPOINTS.ATHLETE.SEARCH_BY_NAME, payload);
  }

  checkUsernameAvailability(username) {
    return baseApi.get(`/athlete/check-username?username=${encodeURIComponent(username)}`);
  }

  getAthletesForPrint(params = {}) {
    let url = API_CONFIG.ENDPOINTS.ATHLETE.PRINT;
    if (params && Object.keys(params).length > 0) {
      const qs = Object.keys(params)
        .filter(
          (k) =>
            params[k] !== undefined && params[k] !== null && params[k] !== "",
        )
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join("&");
      if (qs) {
        url = `${url}?${qs}`;
      }
    }
    return baseApi.get(url);
  }

  updateAthlete(id, data) {
    return baseApi.put(API_CONFIG.ENDPOINTS.ATHLETE.UPDATE(id), data);
  }

  deleteAthlete(id) {
    return baseApi.delete(API_CONFIG.ENDPOINTS.ATHLETE.DELETE(id));
  }
}

export const athleteService = new AthleteService();
